import { Progress as SemanticProgress } from 'semantic-ui-react';
import styled from 'styled-components';

const Progress = styled(SemanticProgress)`
  &.ui.progress {
    width: 100%;
    background: ${(props) => props.theme.color.progressOutline};

    .bar {
      background: ${(props) => props.theme.color.progress};
    }
  }
`;

export default Progress;
